import React from 'react';

// Prevent Enter in text/number inputs from implicitly submitting the form —
// only the focused submit button (or a focused option in a popup) should submit.
export const preventImplicitSubmit = (
  event: React.KeyboardEvent<HTMLFormElement>,
) => {
  const target = event.target as HTMLElement;
  if (event.key === 'Enter' && target.tagName === 'INPUT') {
    event.preventDefault();
  }
};
